import BaseNodeModel from "../BaseNodeModel";

export default class DtmfNodeModel extends BaseNodeModel {
    /**
     * Report node model
     * @module DtmfNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Dtmf Menu";
        this.props.colorClass = "red";
        this.props.iconClass = "align-justify";
        this.DEFAULT_COLOR_CLASS = "red";
        this.applyProps(props);
    }
    getConfig(key) {
        return super.getConfig(key);
    }

    setConfig(key, value) {
        super.setConfig(key, value);
    }
    getOutputSuggestions() {
        const suggestion = super.getOutputSuggestions();

        var values = [];

        const intents = window.apm.knowledgeBase.getIntents();
        var inte = [];
        for (var i = 0; i < this.props.config.selections.length; i++) {
            if (this.props.config.selections[i].value !== "") {
                inte.push(this.props.config.selections[i].value);
            }
        }
        for (var i = 0; i < inte.length; i++) {
            const selection = window.apm.knowledgeBase.getIntentIndexFromValue(inte[i]);
            if (selection < 0) {
                continue;
            }
            const optionName = intents[selection].name;
            values.push(optionName);
        }
        suggestion.value = values;
        return suggestion;
    }
    getConfigViews() {
        const configView = [
            {
                type: "ItemList", key: "inputTimeOut",
                view: "keyValue", updateOnly: true
            },
            {
                type: "ItemList", 
                label: this.getPropLabel("selection_label"), 
                view: "keyValue", 
                key: "selections",
                updateOnly: true,
                pairKeyView: {
                    type: "Label", 
                    key: "key"
                },
                pairValueView: { 
                    type: "Dropdown", 
                    key: "value", 
                    options: window.apm.knowledgeBase.getIntents(),
                    optionName: "Select Intent",
                    disabled:this.props.isCommonModule,
                }
            }];
        return [
            ...this.getConfigViewNameField(),
            ...[
                { type: "Textarea", label: this.getPropLabel("description"), key: "description"}
            ],
            ...configView,
            ...[
                { type: "hr" },
                { type: "Input", label: this.getPropLabel("dtmfInterDigitTimeout"), key: "dtmfInterDigitTimeout", hint: this.getPropLabel("time_in_milliseconds"), tooltip: "How long the voice browser will wait between DTMF key presses before assuming someone is done", readOnly: this.props.isCommonModule},
                { type: "Input", label: this.getPropLabel("dtmfTerminationKey"), key: "dtmfTerminationKey", hint: this.getPropLabel("typically_a_hash"), tooltip: "What key ends DTMF input.",readOnly: this.props.isCommonModule},
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note",readOnly: this.props.isCommonModule,
            }
            ]
        ];
    }
}